import { Receivable, Document } from './OperationPageViewBackend';

export type EditedReceivable = {
    document_id: string;
    receivable_number: string;
    receivable: Receivable;
    document: Omit<Document, 'receivables'>;
};

const buildKey = (documentId: string, receivableNumber: string): string =>
    `${documentId}::${receivableNumber}`;

const store = new Map<string, EditedReceivable>();

export const editedReceivablesStore = {
    upsert(document: Document, receivable: Receivable): void {
        const key = buildKey(document.document_id, receivable.receivable_number);
        const { receivables, ...documentWithoutReceivables } = document;
        const entry: EditedReceivable = {
            document_id: document.document_id,
            receivable_number: receivable.receivable_number,
            receivable: { ...receivable },
            document: { ...documentWithoutReceivables },
        };
        store.set(key, entry);
    },

    getAll(): EditedReceivable[] {
        return Array.from(store.values());
    },

    buildPayload(): { documents: (Omit<Document, 'receivables'> & { receivables: Receivable[] })[] } {
        const grouped = new Map<string, { document: Omit<Document, 'receivables'>; receivables: Receivable[] }>();

        Array.from(store.values()).forEach(entry => {
            const existing = grouped.get(entry.document_id);
            if (existing) {
                existing.receivables.push(entry.receivable);
            } else {
                grouped.set(entry.document_id, {
                    document: entry.document,
                    receivables: [entry.receivable],
                });
            }
        });

        return {
            documents: Array.from(grouped.values()).map(({ document, receivables }) => ({
                ...document,
                receivables,
            })),
        };
    },

    clear(): void {
        store.clear();
    },
};
